<template>
  <v-tooltip :disabled="text === null" bottom>
    <template #activator="{on}">
      <v-chip :color="color" :text-color="textColor" class="travel-service-chips my-1" v-on="on">
        <v-icon class="small mr-1 my-1" v-if="icon !== null">{{ icon }}</v-icon>
        {{ tooltip }}
      </v-chip>
    </template>

    {{ text }}
  </v-tooltip>
</template>

<script>
import { singleServiceOrderStatus } from "../../staticData/ServiceOrder";

export default {
  name: "SingleServiceOrderChip",
  components: {},
  props: {
    text: {
      required: false,
      default: null
    },
    status: {
      required: true
    }
  },
  computed: {
    singleServiceOrderStatus,
    tooltip() {
      return this.singleServiceOrderStatus.find(v => v.value === this.status).text === this.text
        ? null
        : this.singleServiceOrderStatus.find(v => v.value === this.status).text;
    },
    icon() {
      return this.singleServiceOrderStatus.find(v => v.value === this.status).icon;
    },
    textColor() {
      return this.singleServiceOrderStatus.find(v => v.value === this.status).textColor;
    },
    color() {
      return this.singleServiceOrderStatus.find(v => v.value === this.status).color;
    }
  }
};
</script>

<style>
.travel-service-chips {
  /*max-width: 150px;*/
  height: auto !important;
}
.travel-service-chips .v-chip__content {
  height: auto;
  white-space: normal;
}
</style>
